// The requisition-scoped candidate page's own words (UAT D-13, lane B3-FU): `#requisitions/R-####/candidates/<application>`
// in Mission Control (views/candidate/ApplicationPage.tsx). Every entry quotes his glossary; the D0 label suites
// discover this module (a lane folder of src/views) and hold it to the same rules as src/mc. Words the design system or
// the candidate screens already define (Application, Source, Status, Requisition, the DC-31 columns, Held, Internal,
// the aging line) are imported from them, never redefined here.

import { defineLabels } from "@/mc/labels";

const APPLICATION = "\"Each application retains its own stage, status, scorecards, communications, offer outcome, and disposition.\"";
const HOLD = "| Hold reason / age | \"Hold requires reason and age\"";

/** The stage card's title and the application card's field names. */
export const APPLICATION_LABELS = /* @__PURE__ */ defineLabels({
  stage: { text: "Stage" },
  holdReason: { text: "Hold reason" },
});
